import React, { useState, useEffect, useCallback } from "react";
import SaveButton from "../../saveButton";
import CancelButton from "../../cancelButton";
import FilterInput from "../../../filters/filterInput";
import { getUsersByExcel, getUsersForAssigned, assignedUsersToSurvey, downloadUsersTemplate, getUsersFromExcel } from "../../../../client/surveys";
import { useAuth } from "../../../../context/auth";
import ModalSuccess from "../../../shared/modals/modalSuccess";
import ModalAlertWarning from "../../../shared/modals/modalAlertWarning";
import DownloadDocumentButton from "../../../shared/downloadDocument";
import { axiosInstance } from '../../../../client';

const UserDataStep = ({ savedFormData, surveyId, onBack, onFormSent, mode ="create" }) => {
  const { user } = useAuth();
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);

  const [uploadedSuppliers, setUploadedSuppliers] = useState([]);
  const [uploadedUsers, setUploadedUsers] = useState([]); 
  const [notFoundEmails, setNotFoundEmails] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadingUsers, setUploadingUsers] = useState(false); 
  
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]); 
  const [isSearching, setIsSearching] = useState(false);
  const [showSearchResults, setShowSearchResults] = useState(false);

  const [loadingUsers, setLoadingUsers] = useState(false);
  const [showModalSuccess, setShowModalSuccess] = useState({
    show: false,
    excelData: null
  });
  const [showModalAlertWarning, setShowModalAlertWarning] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [searchSectionActive, setSearchSectionActive] = useState(true);
  const [uploadSectionActive, setUploadSectionActive] = useState(true);
  
  const searchUsers = useCallback(async (term) => {
    if (!term.trim()) {
      setSearchResults([]);
      setShowSearchResults(false);
      return;
    }

    try {
      setIsSearching(true);
      const response = await getUsersForAssigned(term);
      
      if (response.data && Array.isArray(response.data)) {
        const filteredResults = response.data.filter(user => 
          !selectedUsers.some(selected => selected.id === user.id)
        );
        setSearchResults(filteredResults);
        setShowSearchResults(true);
      } else {
        setSearchResults([]);
      }
    } catch (error) {
      console.error("Error al buscar usuarios:", error);
      setSearchResults([]);
    } finally {
      setIsSearching(false);
    }
  }, [selectedUsers]);


  const handleUsersFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const validExtensions = ['.xlsx', '.xls'];
    const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
    
    if (!validExtensions.includes(fileExtension)) {
      setErrorMessage("Por favor, sube un archivo Excel válido (.xlsx, .xls)");
      setShowModalAlertWarning(true);
      return;
    }

    try {
      setUploadingUsers(true);
      const response = await getUsersFromExcel(file);
      

      if (response.data && response.data.users) {
        setUploadedUsers(response.data.users);
        setNotFoundEmails(response.data.notFoundEmails || []);

        if (response.data.users.length > 0) {
          setSearchSectionActive(false);
        }
        if (response.data.summary) {

        }
      }
    } catch (error) {
      console.error("Error al subir archivo de usuarios:", error);
      let errorMsg = "Error al procesar el archivo";
      
      if (error.response) {
        errorMsg = error.response.data.message || "Error al procesar el archivo Excel de usuarios";
      }
      
      setErrorMessage(errorMsg);
      setShowModalAlertWarning(true);
      setUploadedUsers([]);
      setNotFoundEmails([]);
    } finally {
      setUploadingUsers(false);
      event.target.value = '';
    }
  };

const handleClearUploadedUsers = () => {
  setUploadedUsers([]);
  setNotFoundEmails([]);
  setSearchSectionActive(true);
};

  const getUserIdsFromUploadedUsers = () => {
    const userIds = uploadedUsers.map(user => user.id);
    return userIds;
  };

const handleFileUpload = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  const validExtensions = ['.xlsx', '.xls'];
  const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
  
  if (!validExtensions.includes(fileExtension)) {
    setErrorMessage("Por favor, sube un archivo Excel válido (.xlsx, .xls)");
    setShowModalAlertWarning(true);
    return;
  }

  try {
    setUploading(true);
    const response = await getUsersByExcel(file);
    
    if (response.data && response.data.suppliersWithUsers) {
      setUploadedSuppliers(response.data.suppliersWithUsers);
      
      if (response.data.summary) {

      }
    }
  } catch (error) {
    console.error("Error al subir archivo:", error);
    let errorMsg = "Error al procesar el archivo";
    
    if (error.response) {
      errorMsg = error.response.data.message || "Error al procesar el archivo Excel";
    }
    
    setErrorMessage(errorMsg);
    setShowModalAlertWarning(true);
    setUploadedSuppliers([]);
  } finally {
    setUploading(false);
    event.target.value = '';
  }
};

const getUserIdsFromUploadedSuppliers = () => {
  const userIds = [];
  
  uploadedSuppliers.forEach(supplier => {
    
    if (supplier.users && Array.isArray(supplier.users)) {
      
      supplier.users.forEach(user => {
        
        if (user.userId && !userIds.includes(user.userId)) {
          userIds.push(user.userId);
        }
      });
    } else {
    }
  });
  
  return userIds;
};

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      searchUsers(searchTerm);
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm, searchUsers]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSelectUser = (user) => {
    if (!selectedUsers.some(selected => selected.id === user.id)) {
      const updatedUsers = [...selectedUsers, user];
      setSelectedUsers(updatedUsers);

      if (updatedUsers.length > 0) {
        setUploadSectionActive(false);
      }
    }
    
    setSearchTerm("");
    setShowSearchResults(false);
  };

const handleRemoveUser = (userId) => {
  const updatedUsers = selectedUsers.filter(user => user.id !== userId);
  setSelectedUsers(updatedUsers);
  
  if (updatedUsers.length === 0) {
    setUploadSectionActive(true);
  }
};

  const getUserIdsByRecipientTypes = async () => {
    const userUserIds = selectedUsers.map(user => user.id);
    const uploadedSupplierUserIds = getUserIdsFromUploadedSuppliers();
    const uploadedUserIds = getUserIdsFromUploadedUsers(); 
    const allUserIds = [...new Set([...userUserIds, ...uploadedSupplierUserIds, ...uploadedUserIds])];
    
    return allUserIds;
  };


  const handleSendForm = async () => {
    if (mode === "create" && (!savedFormData || !surveyId)) {
      setErrorMessage("No hay datos del formulario para enviar");
      setShowModalAlertWarning(true);
      return;
    }

    if (mode === "edit" && !surveyId) {
      setErrorMessage("No se encontró el ID de la encuesta");
      setShowModalAlertWarning(true);
      return;
    }

    const hasSelectedRecipients =  selectedUsers.length > 0 ||
                                 uploadedSuppliers.length > 0  ||
                                 uploadedUsers.length > 0;

    if (selectedUsers.length > 0 && uploadedUsers.length > 0) {
      setErrorMessage("No puedes usar el buscador y subir una lista de usuarios al mismo tiempo. Por favor, usa solo una opción.");
      setShowModalAlertWarning(true);
      return;
    }
    
    if (!hasSelectedRecipients) {
      setErrorMessage("Por favor, selecciona al menos un usuario o sube una lista de proveedores");
      setShowModalAlertWarning(true);
      return;
    }

    try {
      setLoadingUsers(true);
      
      const userIds = await getUserIdsByRecipientTypes();

      if (userIds.length === 0) {
        setErrorMessage("No se encontraron destinatarios para enviar la encuesta");
        setShowModalAlertWarning(true);
        return;
      }

      const response = await assignedUsersToSurvey(surveyId, userIds);
      
      
    if (response.status === 200) {
      setShowModalSuccess({
        show: true,
        excelData: response.data.excelReport 
      });
    }
    } catch (error) {
      console.error("Error al asignar usuarios a la encuesta:", error);
      let errorMsg = "Error inesperado: " + error.message;
      
      if (error.response) {
        errorMsg = "Error al enviar la encuesta: " + (error.response.data.message || error.response.statusText);
      } else if (error.request) {
        errorMsg = "Error de conexión. Por favor, verifica tu conexión a internet.";
      }
      
      setErrorMessage(errorMsg);
      setShowModalAlertWarning(true);
    } finally {
      setLoadingUsers(false);
    }
  };

const handleSuccessModalClose = () => {
  setShowModalSuccess({ show: false, excelData: null });
  if (onFormSent) {
    onFormSent();
  }
};

  const handleWarningModalClose = () => {
    setShowModalAlertWarning(false);
  };


  const CircularCheckbox = ({email, name, onRemove }) => (
    <div className="flex items-center justify-between w-full gap-2 py-1 border-b border-[#808080]">
      <div 
        className="flex items-center gap-2"
      >
        <div className="w-2 h-2 rounded-full bg-blue"></div>
        <p className="text-sm break-all font-itcmedium">
          {name} <span className="break-all font-itcbook text-[#52526C]">({email})</span>
        </p>

      </div>
      {onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="transition-colors text-red hover:text-red-700"
          title="Eliminar usuario"
        >
          <svg width="16" height="16" viewBox="0 0 20 21" fill="currentColor">
            <path d="M12.7008 3.60083L12.945 5.29167H16.25C16.4158 5.29167 16.5747 5.35751 16.6919 5.47472C16.8092 5.59193 16.875 5.75091 16.875 5.91667C16.875 6.08243 16.8092 6.2414 16.6919 6.35861C16.5747 6.47582 16.4158 6.54167 16.25 6.54167H15.6092L14.8817 15.0292C14.8375 15.5458 14.8017 15.9708 14.7442 16.3142C14.6858 16.6717 14.5967 16.9917 14.4225 17.2883C14.149 17.7543 13.7424 18.1278 13.255 18.3608C12.945 18.5083 12.6183 18.5692 12.2567 18.5975C11.9092 18.625 11.4833 18.625 10.965 18.625H9.035C8.51667 18.625 8.09083 18.625 7.74333 18.5975C7.38167 18.5692 7.055 18.5083 6.745 18.3608C6.25757 18.1278 5.85098 17.7543 5.5775 17.2883C5.4025 16.9917 5.315 16.6717 5.25583 16.3142C5.19833 15.97 5.1625 15.5458 5.11833 15.0292L4.39083 6.54167H3.75C3.58424 6.54167 3.42527 6.47582 3.30806 6.35861C3.19085 6.2414 3.125 6.08243 3.125 5.91667C3.125 5.75091 3.19085 5.59193 3.30806 5.47472C3.42527 5.35751 3.58424 5.29167 3.75 5.29167H7.055L7.29917 3.60083L7.30833 3.55C7.46 2.89167 8.025 2.375 8.73333 2.375H11.2667C11.975 2.375 12.54 2.89167 12.6917 3.55L12.7008 3.60083Z"/>
          </svg>
        </button>
      )}
    </div>
  );

  const handleDownloadTemplate = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const response = await axiosInstance.get('/Advertisement/ExportTemplate', {
        responseType: 'blob',
      });

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      const contentDisposition = response.headers['content-disposition'];
      let fileName = 'Plantilla_de_proveedores.xlsx';

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (fileNameMatch && fileNameMatch.length > 1) {
          fileName = fileNameMatch[1];
        }
      }

      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);

    } catch (error) {
      console.error('Error al descargar el archivo:', error);
      setErrorMessage('No se pudo descargar el archivo, intenta de nuevo.');
      setShowError(true);
    } finally {
      setLoading(false);
    }
  };

const handleDownloadUsersTemplate = async (e) => {
  e.preventDefault();

  try {
    setLoading(true);
    const response = await downloadUsersTemplate();

    const blob = new Blob([response.data], {
      type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    const contentDisposition = response.headers['content-disposition'];
    let fileName = 'Plantilla_registro_usuarios_encuestas.xlsx';

    if (contentDisposition) {
      const utf8Match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
      const regularMatch = contentDisposition.match(/filename="?(.+)"?/);
      
      if (utf8Match && utf8Match.length > 1) {
        fileName = decodeURIComponent(utf8Match[1]);
      } else if (regularMatch && regularMatch.length > 1) {
        fileName = regularMatch[1];
        
        if (fileName.includes('; filename_=')) {
          const parts = fileName.split('; filename_=');
          if (parts.length > 1) {
            fileName = parts[1];
            fileName = fileName.replace(/^'+|'+$/g, '');
          }
        }
      }
    }

    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 100);

  } catch (error) {
    console.error('Error al descargar la plantilla de usuarios:', error);
    setErrorMessage('No se pudo descargar la plantilla de usuarios, intenta de nuevo.');
    setShowModalAlertWarning(true);
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="flex flex-col gap-6 pt-4">
      <h2 className="text-2xl text-blue font-itcmedium">Seleccione a quienes se realizará el envío</h2>
      
      <div className="flex flex-col items-start justify-start w-full gap-4">
        <DownloadDocumentButton
          text="Descargar plantilla de proveedores"
          onClick={handleDownloadTemplate}
        />
        <label className="inline-flex items-center gap-2 cursor-pointer ">
          <p className="text-xs hover:underline md:text-sm font-itcmedium text-blue ">
            {uploading ? "Procesando archivo..." : "Subir lista de proveedores"}
          </p>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1_18127)">
              <path d="M16.4405 15.1001C20.0405 14.7901 21.5105 12.9401 21.5105 8.8901V8.7601C21.5105 4.2901 19.7205 2.5001 15.2505 2.5001H8.74047C4.27047 2.5001 2.48047 4.2901 2.48047 8.7601V8.8901C2.48047 12.9101 3.93047 14.7601 7.47047 15.0901"
              stroke="#007696" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 22V9.12"
              stroke="#007696" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15.3504 11.3496L12.0004 7.99961L8.65039 11.3496"
              stroke= "#007696" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
              <clipPath id="clip0_1_18127">
              <rect width="24" height="24" fill="white" transform="matrix(1 0 0 -1 0 24)"/>
              </clipPath>
              </defs>
          </svg>
          <input
            type="file"
            accept=".xlsx,.xls,.ods"
            className="hidden"
            onChange={handleFileUpload}
            disabled={uploading}
          />
        </label>

        {uploadedSuppliers.length > 0 && (
          <div className="w-full p-3 bg-white border rounded-md shadow border-blue-light">
            <h4 className="mb-2 text-lg font-itcmedium text-blue">Proveedores cargados:</h4>
            <div className="space-y-4">
              {uploadedSuppliers.map((supplier) => (
                <div key={supplier.supplierId} className="p-3 border border-gray-200 rounded-md">
                  <div className="mb-2 text-sm font-itcmedium text-blue">
                    {supplier.supplierName} 
                    <span className="font-itcbook text-[#52526C]"> ({supplier.supplierCode})</span>
                  </div>
                  {supplier.users && supplier.users.length > 0 ? (
                    <div >
                      <div className="mb-1 text-sm text-gray-600 font-itcmedium">Usuarios:</div>
                      <ul className="space-y-1">
                        {supplier.users.map((user) => (
                          <li key={user.userId} className="text-sm font-itcmedium">
                            • {user.userName} <span className="text-gray-700 font-itcbook">({user.userEmail})</span> 
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    <div className="ml-4 text-xs text-red-500 font-itcbook">
                      Este proveedor no tiene usuarios asociados
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="flex flex-col gap-3">
        <h2 className="text-2xl text-blue font-itcmedium">Buscar usuarios</h2>
        <div className="relative w-[285px] sm:w-[380px] ">
          <FilterInput 
            title="Buscar usuarios:"
            value={searchTerm}
            onChange={handleSearchChange}
            placeholder="Escribe el nombre"
            classname="w-[240px]"
            gray={!searchSectionActive} 
            disabled={!searchSectionActive}
          />
          
          {showSearchResults && searchSectionActive &&(
            <div className="absolute w-[195px] sm:w-[240px] right-0 sm:right-[26px] z-10  mt-1 overflow-y-auto bg-white border border-blue-light rounded-lg shadow-lg top-full max-h-32">
              {isSearching ? (
                <div className="p-3 text-center text-gray-500 font-itcbook">Buscando...</div>
              ) : searchResults.length === 0 ? (
                <div className="p-3 text-center text-gray-500 font-itcbook">No se encontraron usuarios</div>
              ) : (
                searchResults.map(user => (
                  <div
                    key={user.id}
                    className="p-3 border-b border-gray-200 cursor-pointer hover:bg-blue-50"
                    onClick={() => handleSelectUser(user)}
                  >
                    <div className="text-sm font-itcmedium">
                      {user.name}
                    </div>
                    <div className="text-xs text-gray-600 font-itcbook">
                      {user.email}
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
  
        {selectedUsers.length > 0 && (
          <>
            <h3 className="text-lg font-itcmedium text-blue">Usuarios seleccionados:</h3>
            {selectedUsers.map(user => (
              <CircularCheckbox
                key={user.id}
                name={user.name}
                email={user.email}
                checked={true}
                onChange={() => {}} 
                onRemove={() => handleRemoveUser(user.id)}
              />
            ))} 
          </>
        )}

        <div className="flex flex-col items-start justify-start w-full gap-4">
          <DownloadDocumentButton
            text="Descargar plantilla de usuarios"
            onClick={handleDownloadUsersTemplate}
            loading={loading}
            disabled={!uploadSectionActive}
            hasData={uploadSectionActive}
          />
  
          <label className={`inline-flex items-center gap-2 ${uploadSectionActive ? 'cursor-pointer' : 'cursor-not-allowed'}`}>
            <p className={`text-xs md:text-sm font-itcmedium ${uploadSectionActive ? 'text-blue hover:underline' : 'text-gray'}`}>
              {uploadingUsers ? "Procesando archivo..." : "Subir lista de usuarios"}
            </p>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1_18127)">
              <path d="M16.4405 15.1001C20.0405 14.7901 21.5105 12.9401 21.5105 8.8901V8.7601C21.5105 4.2901 19.7205 2.5001 15.2505 2.5001H8.74047C4.27047 2.5001 2.48047 4.2901 2.48047 8.7601V8.8901C2.48047 12.9101 3.93047 14.7601 7.47047 15.0901"
              stroke={uploadSectionActive ? "#007696" : "#808080"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 22V9.12"
              stroke={uploadSectionActive ? "#007696" : "#808080"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15.3504 11.3496L12.0004 7.99961L8.65039 11.3496"
              stroke={uploadSectionActive ? "#007696" : "#808080"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
              <clipPath id="clip0_1_18127">
              <rect width="24" height="24" fill="white" transform="matrix(1 0 0 -1 0 24)"/>
              </clipPath>
              </defs>
            </svg>
            <input
              type="file"
              accept=".xlsx,.xls,.ods"
              className="hidden"
              onChange={handleUsersFileUpload}
              disabled={uploadingUsers || !uploadSectionActive}
            />
          </label>
  
          {uploadedUsers.length > 0 && (
            <div className="w-full p-3 bg-white border rounded-md shadow border-green">
              <div className="flex items-center justify-between mb-2">
                <h4 className="text-lg text-green font-itcmedium">Usuarios cargados exitosamente:</h4>

                <button
                  onClick={handleClearUploadedUsers}
                  className="transition-colors text-red hover:text-red-700"
                  title="Eliminar lista de usuarios"
                >
                  <svg width="16" height="16" viewBox="0 0 20 21" fill="currentColor">
                    <path d="M12.7008 3.60083L12.945 5.29167H16.25C16.4158 5.29167 16.5747 5.35751 16.6919 5.47472C16.8092 5.59193 16.875 5.75091 16.875 5.91667C16.875 6.08243 16.8092 6.2414 16.6919 6.35861C16.5747 6.47582 16.4158 6.54167 16.25 6.54167H15.6092L14.8817 15.0292C14.8375 15.5458 14.8017 15.9708 14.7442 16.3142C14.6858 16.6717 14.5967 16.9917 14.4225 17.2883C14.149 17.7543 13.7424 18.1278 13.255 18.3608C12.945 18.5083 12.6183 18.5692 12.2567 18.5975C11.9092 18.625 11.4833 18.625 10.965 18.625H9.035C8.51667 18.625 8.09083 18.625 7.74333 18.5975C7.38167 18.5692 7.055 18.5083 6.745 18.3608C6.25757 18.1278 5.85098 17.7543 5.5775 17.2883C5.4025 16.9917 5.315 16.6717 5.25583 16.3142C5.19833 15.97 5.1625 15.5458 5.11833 15.0292L4.39083 6.54167H3.75C3.58424 6.54167 3.42527 6.47582 3.30806 6.35861C3.19085 6.2414 3.125 6.08243 3.125 5.91667C3.125 5.75091 3.19085 5.59193 3.30806 5.47472C3.42527 5.35751 3.58424 5.29167 3.75 5.29167H7.055L7.29917 3.60083L7.30833 3.55C7.46 2.89167 8.025 2.375 8.73333 2.375H11.2667C11.975 2.375 12.54 2.89167 12.6917 3.55L12.7008 3.60083Z"/>
                  </svg>
                </button>
              </div>
              <ul className="text-sm list-disc list-inside">
                {uploadedUsers.map((user) => (
                  <li key={user.id} className="font-itcmedium">
                    {user.name} <span className="text-[#52526C] font-itcbook">({user.email})</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
  
          {/* Mostrar emails no encontrados */}
          {notFoundEmails.length > 0 && (
            <div className="w-full p-3 bg-white border rounded-md shadow border-red">
              <h4 className="mb-2 text-lg text-red font-itcmedium">Correos no encontrados:</h4>
              <ul className="list-disc list-inside ">
                {notFoundEmails.map((email, index) => (
                  <li key={index} className="text-sm font-itcmedium">
                    {email}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

      </div>

      <div className="flex items-center justify-center w-full gap-4 pt-16">
        <SaveButton 
          title={loadingUsers ? "Cargando..." : "Enviar"} 
          onClick={handleSendForm} 
          disabled={loadingUsers}
        />
        <CancelButton onClick={onBack} />
      </div>

      <ModalSuccess
        showModalSuccess={showModalSuccess.show}
        closeModalSuccess={handleSuccessModalClose}
        fill="green"
        text="Se realizó el envío a los usuarios exitosamente"
        excel={true}
        excelData={showModalSuccess.excelData}
      />

      <ModalAlertWarning
        showModalAlertWarning={showModalAlertWarning}
        closeModal={handleWarningModalClose}
        error={errorMessage}
        accept={handleWarningModalClose}
      />
    </div>
  );
};

export default UserDataStep;